import * as sideSheetsNames from 'constants/sidePanels';
import ManuallyAddBankAccountSideSheet from 'modules/connectBank/ManuallyAddBankAccountSideSheet';
export const sideSheetsMap = {
    [sideSheetsNames.sidePanelNameManuallyAddBankAccount]: ManuallyAddBankAccountSideSheet,
};
